import styled from 'styled-components';

export const StyledElement = styled.img`
  margin-right: 20px;
`;

export const StyledSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 60px;
`;
